export default __webpack_public_path__ + "static/media/cancel.c0255bb3.svg";